'use strict';

angular.module('shiftTraderApp')
  .factory('ShiftTradeResponsesResource', function ($resource, ServerUrls) {
    var apiBase = ServerUrls.current.railsApi;

    if (_.contains(apiBase, ':')) {
      apiBase = apiBase.replace(':', '\\:');
    }
    return $resource(apiBase + 'shift_trade_responses');
  });
